import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  Renderer2
} from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { Subscription } from "rxjs/internal/Subscription";

@Directive({
  selector: "[timeMask]"
})
export class TimeDirective {
  private _control!: AbstractControl;
  private _preValue: string = "";
  private _id: string = "";
  @Input()
  set control(control: AbstractControl) {
    this._control = control;
  }
  @Input()
  set preValue(value: string) {
    this._preValue = value;
  }
  @Input()
  set id(value: string) {
    this._id = value;
  }

  private sub!: Subscription;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.validate();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  filterNonNumeric(input: string) {
    return input.replace(/\D/g, "");
  }
  public getStart() {
    return this.renderer.selectRootElement("#" + this._id).selectionStart;
  }
  public getEnd() {
    return this.renderer.selectRootElement("#" + this._id).selectionEnd;
  }
  public isBackspace(next: string) {
    return this._preValue.length > next.length;
  }
  public setRange(start: number, end: number) {
    this.renderer
      .selectRootElement("#" + this._id)
      .setSelectionRange(start, end);
  }

  validate() {
    this.sub = this._control.valueChanges.subscribe(data => {
      var numbers = this.filterNonNumeric(data);
      if (numbers.length == 0) {
        this._control.setValue("", { emitEvent: false });
        return;
      } else if (!["0", "1"].includes(numbers[0])) {
        numbers = "0" + numbers;
      }
      var tod = (data as string).toLowerCase().includes("a")
        ? "AM"
        : (data as string).toLowerCase().includes("p")
        ? "PM"
        : "";
      // let start = this.getStart();
      // let end = this.getEnd();
      if (this.isBackspace(data)) {
        if ((data as string).indexOf(":") == data.length - 1) {
          this._control.setValue(data.replace(":", ""), { emitEvent: false });
        } else if ((data as string).indexOf("+") == data.length - 1) {
          this._control.setValue(data.replace("+", "").trim(), {
            emitEvent: false
          });
        } else if (data == "0") {
          this._control.setValue("", { emitEvent: false });
        } else {
          this._control.setValue(data.trim(), { emitEvent: false });
        }
        // this.setRange(start, end);
      } else {
        var result = "";
        var hour = numbers.slice(0, 2);
        var minute = numbers.slice(2, 4);
        var tom = data.includes("+") && tod != "PM" ? "+1" : "";
        result = [hour, minute].join(":").trim() + " " + tod + " " + tom;
        this._control.setValue(result.trim(), { emitEvent: false });
      }
    });
  }
}
